import { s as t, _ as d } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as o, c as i } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var p = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  d({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.837 8H31.19c.645 2.723.84 5.507.808 8H.003v-.017C-.028 13.528.197 10.751.838 8Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.032 2.456-.193 5.233-.834 7.984H.836c-.67-2.744-.864-5.516-.833-8Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.835 24h30.327l-.029.124s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124L.836 24Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.189 8H.837l.03-.125S1.894 2.957 6.341 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646l.022.091Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M3.307 3.307 16 16 3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .524-2.505 2.441-4.568Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M7 20.874c-.353.082-.72.126-1.099.126C3.194 21 1 18.761 1 16s2.194-5 4.901-5c.378 0 .746.044 1.099.126-2.178.509-3.803 2.498-3.803 4.874 0 2.376 1.625 4.365 3.803 4.874-2.178-.509 0 0 0 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m7 12.733-.588.41.207-.686-.57-.433.716-.014.235-.677.235.677.716.014-.57.433.207.685L7 12.733Zm0 2.445-.588.409.207-.686-.57-.432.716-.015.235-.676.235.676.716.015-.57.432.207.686-.588-.41Zm0 2.444-.588.41.207-.686-.57-.433.716-.014.235-.677.235.677.716.014-.57.433.207.685L7 17.622Zm0 2.445-.588.409.207-.686-.57-.432.716-.015.235-.676.235.676.716.015-.57.432.207.686-.588-.41Z",
      clipRule: "evenodd"
    }
  )
), a = o(p)`
  ${t}
  ${i}
`, Z = a;
export {
  Z as default
};
